import moment from 'moment';

export const pdfHeader = (pdf, dataElementName, transactionHash) => {
	pdf.setFontSize(12);

	const margin = 20;
	const boxWidth = pdf.internal.pageSize.getWidth() - margin * 2;;
	const boxHeight = 80;

	pdf.setDrawColor(215, 218, 227); // #D7DAE3
	pdf.setLineWidth(0.5);
	pdf.setFillColor(255, 255, 255); // White background
	pdf.roundedRect(margin, margin, boxWidth, boxHeight, 3, 3, "FD"); // 'FD' means fill and stroke

	// Title
	pdf.setFont("helvetica", "bold");
	pdf.setFontSize(14);
	pdf.setTextColor(20, 24, 30)
	pdf.text(
		"COPY – Please See Electronic Copy For The Latest Version",
		margin + 10,
		margin + 20
	);

	// Subtitle (italic)
	pdf.setFont("helvetica", "italic");
	pdf.setFontSize(12);
	pdf.setTextColor(96, 99, 107); // #60636B
	pdf.text(
		`This is a copy of the ${dataElementName}. Refer electronic copy for the latest version`,
		margin + 10,
		margin + 38
	);

	// Transaction Hash and Timestamp
	pdf.setFont("helvetica", "normal");
	pdf.setFontSize(12);
	pdf.setTextColor(96, 99, 107); // #60636B
	const transaction = `Transaction Hash : ${transactionHash}`;
    const now = moment(new Date());
	const timestamp = `Printed Timestamp (ISO 8601) : ${now.toISOString()}`;
	pdf.text(`${transaction}   |   ${timestamp}`, margin + 10, margin + 60);
};